import React, { ReactElement } from 'react'
import s from './OokaBetterSharedGroup.module.scss'
import { getFastlyUrl } from '@corratech/pylot-image'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
    childLength?: number
}
const OokaBetterSharedItem = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: { image }
    } = props

    const fastlyImageUrl = getFastlyUrl({
        src: image
    })

    return (
        <div className={s['social-slide']}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <img src={fastlyImageUrl} alt="social" loading="lazy" />
        </div>
    )
}
export default OokaBetterSharedItem
